// redux/actionDispatcher/categoryModalDispatcher.js
export const showAddCategoryModal = () => {
    return {
      type: "SHOW_ADD_CATEGORY_MODAL",
    };
  };
  
  export const hideAddCategoryModal = () => {
    return {
      type: "HIDE_ADD_CATEGORY_MODAL",
    };
  };
  